'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BackTop = require('./BackTop');

var _BackTop2 = _interopRequireDefault(_BackTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _BackTop2["default"];
module.exports = exports['default'];